let authToken = ''

const setAuthToken = (token) => {
  window.authToken = token
  authToken = token
}

const getAuthToken = () => {
  return authToken || window.authToken
}

export default {
  setAuthToken,
  getAuthToken
}
